import Vue from 'vue'
import axios from 'axios'
import qs from 'qs'
// 汇率

import { baseURL } from '../config'
var baseURL1 = 'https://product.rakumart.com'
var baseURL2 = 'https://www.rakumart-2c.com:8080'

export const getRate = data => Vue.prototype.getAxios(baseURL + "/index.php", data)
//获取首页全部默认的产品
export const mainProductList = data => Vue.prototype.postAxios(baseURL1 + "/api/product/mainProductList", data)
// 获取全部分类
export const categoryLlist = data => Vue.prototype.getAxios(baseURL1 + "/api/product/category/list", data)
// 一级导航
export const getNavList = data => Vue.prototype.getAxios(baseURL + "/index.php", data)
// 二级导航
export const getSecond = data => Vue.prototype.getAxios(baseURL + "/index.php", data)
// banner
export const getBannerList = data => Vue.prototype.getAxios(baseURL + "/index.php", data)
// 公告
export const getNoticeList = data => Vue.prototype.getAxios(baseURL + "/index.php", data)
// // 推荐
// export const getRecommendList = data => Vue.prototype.getAxios(baseURL + "/index.php", data)

// 推荐
export const getRecommendList = (data) => axios({
  url: baseURL2 + "/api/operation/recommendGoodsShow",
  method: "post",
  data: qs.stringify(data),
  headers: {
    "Content-Type": "application/x-www-form-urlencoded",
  }
})


// 首页产品分类
export const getClass = data => Vue.prototype.getAxios(baseURL + "/index.php", data)
// 首页产品分类对应的 商品
export const getProductList = data => Vue.prototype.getAxios(baseURL + "/index.php", data)
// 咨询
export const consult = data => Vue.prototype.postAxios(baseURL + `/index.php?mod=inc&act=ordersys&str=consult&token=` + localStorage.getItem('token'),
  data
)
export const upload = data => axios({
  url: 'https://admin.rakumart.com/index.php?mod=inc&act=wu_ajax&str=picsearch',
  method: "post",
  data: data,
  headers: {
    "Content-Type": "multipart/form-data"
  }
}
)
// 图片搜索
export const offerImageSearch = data => axios({
  url: baseURL + '/index.php?mod=inc&act=offerImageSearchV2&str=search&token=' + localStorage.getItem('token'),
  method: "post",
  data: qs.stringify(data),
  headers: {
    "Content-Type": "application/x-www-form-urlencoded"
  }
}
)


// 图片提取文字并翻译
export const imageCharacter = data => Vue.prototype.getAxios("https://admin1.rakumart.com/index.php?mod=inc&act=top461", data)

//反馈建议
export const postSuggest = data => axios({
  url: baseURL + '/index.php?mod=inc&act=ordersys&str=postSuggest',
  method: "post",
  data: qs.stringify(data),
  headers: {
    "Content-Type": "application/x-www-form-urlencoded"
  }
})

//上传的接口
export const uploadFile = data => axios({
  url: 'https://www.rakumart-2c.com:8080/api/upload/uploadFile',
  method: "post",
  data: data,
  headers: {
    "Content-Type": "multipart/form-data"
  }
})

// 首页爆品推荐分类
export const hotSaleCates = data => Vue.prototype.postAxios("https://apiwww.rakumart.com/client/hotSaleCates", data)

// 首页爆品推荐分类
export const hotSaleSearch = data => Vue.prototype.postAxios("https://apiwww.rakumart.com/client/hotSaleSearch", data)

//rakuai跳转
export const rakuaiAutoLogin = data => axios({
  url: "https://apiwww.rakumart.com/api/2c/rakuaiAutoLogin",
  method: "post",
  data: qs.stringify(data),
  headers: {
    "Content-Type": "application/x-www-form-urlencoded"
  }
}
)






